import { log } from './utils/debugHelper';
import { isCapacitorBuild } from './utils/platform';

if (process.env.NODE_ENV === `production` && typeof window !== `undefined`) {
  //log('[analytics] Tracking analytics');
} else {
  log(
    '[analytics] Detected non-production environment, not tracking analytics'
  );
}

// ***** Analytics Labels *****
export const EMPLOYER_LABEL = 'employer';
export const STAFF_LABEL = 'job_seeker';
export const LEAD_LABEL = 'lead';
export const RESUME_LABEL = 'resume';
export const JOB_POSTING_LABEL = 'job_posting';
export const COMBO_LABEL = 'combo';
export const PROFILE_PUBLIC_LABEL = 'public_profile';
export const PROFILE_PRIVATE_LABEL = 'private_profile';
export const DAILY_JOB_ALERT_LABEL = 'daily_job_alert';
export const WEEKLY_JOB_ALERT_LABEL = 'weekly_job_alert';
export const ABLE_TO_APPLY_LABEL = 'able_to_apply';
export const PUBLISH_POSTING_LABEL = 'publish_posting';
export const CLOSE_POSTING_LABEL = 'close_posting';

// ***** Analytics Categories *****
export const ENGAGEMENT_CATEGORY = 'engagement';
export const ECOMMERCE_CATEGORY = 'ecommerce';
export const OUTBOUND_CATEGORY = 'outbound';
export const ERROR_CATEGORY = 'error';

// ***** Analytics Action Types *****
export const LOGIN_ACTION = 'LOGIN';
export const LOGOUT_ACTION = 'LOGOUT';
export const DELETE_ACCOUNT_ACTION = 'DELETE_ACCOUNT';
export const CREATE_ACCOUNT_ACTION = 'CREATE_ACCOUNT';
export const SET_JOB_PREFERENCES_ACTION = 'SET_JOB_PREFERENCES';
export const VIEW_ITEMS_ACTION = 'VIEW_ITEMS';
export const VIEW_JOB_ACTION = 'VIEW_JOB';
export const ADD_TO_CART_ACTION = 'ADD_TO_CART';
export const REMOVE_FROM_CART_ACTION = 'REMOVE_FROM_CART';
export const BEGIN_CHECKOUT_ACTION = 'BEGIN_CHECKOUT';
export const ADD_SHIPPING_INFO_ACTION = 'ADD_SHIPPING_INFO';
export const ADD_PAYMENT_INFO_ACTION = 'ADD_PAYMENT_INFO';
export const PURCHASE_ACTION = 'PURCHASE';
export const VIEW_SEARCH_RESULTS_ACTION = 'VIEW_SEARCH_RESULTS';
export const SUBMIT_APPLICATION_ACTION = 'SUBMIT_APPLICATION';
export const SEND_MESSAGE_ACTION = 'SEND_MESSAGE';
export const PROFILE_VISIBILITY_ACTION = 'PROFILE_VISIBILITY';
export const PROFILE_RELOCATE_ACTION = 'PROFILE_RELOCATE';
export const JOB_ALERT_SUBSCRIPTION_ACTION = 'JOB_ALERT_SUBSCRIPTION';
export const PROFILE_COMPLETION_ACTION = 'PROFILE_COMPLETION';
export const OUTBOUND_LINK_ACTION = 'OUTBOUND_LINK_ACTION';
export const GENERATE_LEAD_ACTION = 'GENERATE_LEAD';
export const ASSET_DOWNLOAD_ACTION = 'DOWNLOAD_ASSET';
export const PROMO_CLICK_ACTION = 'PROMO_CLICK';
export const PUBLISH_POSTING_ACTION = 'PUBLISH_POSTING';
export const CLOSE_POSTING_ACTION = 'CLOSE_POSTING';
export const EXIT_INTENT_SURVEY_ACTION = 'EXIT_INTENT_SURVEY';
export const BEGIN_APPLICATION_ACTION = 'BEGIN_APPLICATION';
export const SAVE_RESUME_ACTION = 'SAVE_RESUME';
export const JOB_POSTING_FLOW_OPENED_ACTION = 'JOB_POSTING_FLOW_OPENED';
export const JOB_SETUP_ASSISTANT_CLICKED_ACTION = 'JOB_SETUP_ASSISTANT_CLICKED';
export const UPLOAD_JOB_DESCRIPTION_CLICKED_ACTION =
  'UPLOAD_JOB_DESCRIPTION_CLICKED';
export const FILE_UPLOAD_STARTED_ACTION = 'FILE_UPLOAD_STARTED';
export const SAVE_DRAFT_CLICKED_ACTION = 'SAVE_DRAFT_CLICKED';
export const JOB_POSTING_PUBLISHED_SUCCESS_ACTION =
  'JOB_POSTING_PUBLISHED_SUCCESS';
export const JOB_POSTING_PUBLISHED_ERROR_ACTION = 'JOB_POSTING_PUBLISHED_ERROR';
export const FORM_ABANDONED_ACTION = 'FORM_ABANDONED';
export const CREATE_PRACTICE_BIO_ACTION = 'CREATE_PRACTICE_BIO';
export const SAVE_GO_TO_PROFILE_ACTION = 'SAVE_GO_TO_PROFILE';
export const JOB_SETUP_ASSISTANT_COMPLETED_ACTION =
  'JOB_SETUP_ASSISTANT_COMPLETED';
export const JOB_SETUP_ASSISTANT_ABANDONED_ACTION =
  'JOB_SETUP_ASSISTANT_ABANDONED';
export const SALARY_RECOMMENDATIONS_USED_ACTION = 'SALARY_RECOMMENDATIONS_USED';
export const AI_CONTENT_MARKED_AS_REVIEWED_ACTION =
  'AI_CONTENT_MARKED_AS_REVIEWED';
export const APPLICATION_ABANDONED_ACTION = 'APPLICATION_ABANDONED';
// education_level_multi_select_changed: blocked — field doesn't exist yet (see DP-2103–2113)
export const USER_PROFILE_FETCH_ERROR_ACTION = 'USER_PROFILE_FETCH_ERROR';

function getActionName(actionType: string) {
  switch (actionType) {
    case LOGIN_ACTION:
      return {
        gtag: 'login',
        bing: 'login',
      };
    case LOGOUT_ACTION:
      return {
        gtag: 'logout',
      };
    case CREATE_ACCOUNT_ACTION:
      return {
        gtag: 'sign_up',
        bing: 'sign_up',
        fb: 'CompleteRegistration',
      };
    case VIEW_ITEMS_ACTION:
      return {
        gtag: 'view_item_list',
      };
    case VIEW_JOB_ACTION:
      return {
        gtag: 'view_job',
      };
    case ADD_TO_CART_ACTION:
      return {
        gtag: 'add_to_cart',
      };
    case REMOVE_FROM_CART_ACTION:
      return {
        gtag: 'remove_from_cart',
      };
    case BEGIN_CHECKOUT_ACTION:
      return {
        gtag: 'begin_checkout',
        bing: 'begin_checkout',
        fb: 'InitiateCheckout',
      };
    case ADD_SHIPPING_INFO_ACTION:
      return {
        gtag: 'add_shipping_info',
      };
    case ADD_PAYMENT_INFO_ACTION:
      return {
        gtag: 'add_payment_info',
      };
    case PURCHASE_ACTION:
      return {
        gtag: 'purchase',
        bing: 'purchase',
        fb: 'Purchase',
      };
    case VIEW_SEARCH_RESULTS_ACTION:
      return {
        gtag: 'view_search_results',
        bing: 'view_search_results',
      };
    case SUBMIT_APPLICATION_ACTION:
      return {
        gtag: 'submit_application',
        bing: 'submit_application',
        fb: 'SubmitApplication',
      };
    case PROFILE_VISIBILITY_ACTION:
      return {
        gtag: 'profile_visibility',
      };
    case PROFILE_RELOCATE_ACTION:
      return {
        gtag: 'profile_relocate',
      };
    case PROFILE_COMPLETION_ACTION:
      return {
        gtag: 'profile_completion',
      };
    case OUTBOUND_LINK_ACTION:
      return {
        gtag: 'outbound_link',
      };
    case GENERATE_LEAD_ACTION:
      return {
        gtag: 'generate_lead',
      };
    case ASSET_DOWNLOAD_ACTION:
      return {
        gtag: 'download_asset',
      };
    case PROMO_CLICK_ACTION:
      return {
        gtag: 'promo_click',
      };
    case CLOSE_POSTING_ACTION:
      return {
        gtag: 'close_posting',
      };
    case PUBLISH_POSTING_ACTION:
      return {
        gtag: 'publish_posting',
      };
    case EXIT_INTENT_SURVEY_ACTION:
      return {
        gtag: 'exit_intent_survey',
      };
    case BEGIN_APPLICATION_ACTION:
      return {
        gtag: 'begin_application',
        bing: 'begin_application',
        fb: 'InitiateCheckout',
      };
    case SAVE_RESUME_ACTION:
      return {
        gtag: 'save_resume',
      };
    case JOB_POSTING_FLOW_OPENED_ACTION:
      return {
        gtag: 'job_posting_flow_opened',
      };
    case JOB_SETUP_ASSISTANT_CLICKED_ACTION:
      return {
        gtag: 'job_setup_assistant_clicked',
      };
    case UPLOAD_JOB_DESCRIPTION_CLICKED_ACTION:
      return {
        gtag: 'upload_job_description_clicked',
      };
    case FILE_UPLOAD_STARTED_ACTION:
      return {
        gtag: 'file_upload_started',
      };
    case SAVE_DRAFT_CLICKED_ACTION:
      return {
        gtag: 'save_draft_clicked',
      };
    case JOB_POSTING_PUBLISHED_SUCCESS_ACTION:
      return {
        gtag: 'job_posting_published_success',
      };
    case JOB_POSTING_PUBLISHED_ERROR_ACTION:
      return {
        gtag: 'job_posting_published_error',
      };
    case FORM_ABANDONED_ACTION:
      return {
        gtag: 'form_abandoned',
      };
    case CREATE_PRACTICE_BIO_ACTION:
      return {
        gtag: 'create_practice_bio',
      };
    case SAVE_GO_TO_PROFILE_ACTION:
      return {
        gtag: 'save_go_to_profile',
      };
    case JOB_SETUP_ASSISTANT_COMPLETED_ACTION:
      return {
        gtag: 'job_setup_assistant_completed',
      };
    case JOB_SETUP_ASSISTANT_ABANDONED_ACTION:
      return {
        gtag: 'job_setup_assistant_abandoned',
      };
    case SALARY_RECOMMENDATIONS_USED_ACTION:
      return {
        gtag: 'salary_recommendations_used',
      };
    case AI_CONTENT_MARKED_AS_REVIEWED_ACTION:
      return {
        gtag: 'ai_content_marked_as_reviewed',
      };
    case APPLICATION_ABANDONED_ACTION:
      return {
        gtag: 'application_abandoned',
      };
    case USER_PROFILE_FETCH_ERROR_ACTION:
      return {
        gtag: 'user_profile_fetch_error',
      };
    default:
      return {
        gtag: 'undefined_action',
      };
  }
}

const fallbackDataLayer: any[] = [];
let mixpanelInstancePromise: Promise<any | null> | null = null;

function shouldMirrorEventsToMixpanel() {
  return (
    typeof window !== 'undefined' &&
    isCapacitorBuild &&
    Boolean(process.env.GATSBY_MIXPANEL_TOKEN)
  );
}

async function getMixpanelInstance() {
  if (!shouldMirrorEventsToMixpanel()) {
    return null;
  }

  if (!mixpanelInstancePromise) {
    mixpanelInstancePromise = import('mixpanel-browser')
      .then((module) => {
        const mixpanel = module.default;
        const token = process.env.GATSBY_MIXPANEL_TOKEN;

        if (!token) {
          return null;
        }

        mixpanel.init(token, {
          persistence: 'localStorage',
          track_pageview: false,
        });

        return mixpanel;
      })
      .catch((error) => {
        log('[analytics] Failed to initialize Mixpanel', error);
        return null;
      });
  }

  return mixpanelInstancePromise;
}

// GTM's "Mixpanel Event - Identify" tag fires on login and both registration
// events, keyed on the dataLayer distinctId. Native has no GTM, so the mirror
// reproduces it here.
const IDENTIFY_EVENTS = ['login', 'sign_up'];

// Property names GTM's "Mixpanel Event - Set User Profile" tag (people.set)
// maps the set_user payload onto. The $-prefixed keys are Mixpanel's reserved
// profile properties; the rest keep their dataLayer names.
const PEOPLE_PROPERTY_NAMES: Record<string, string> = {
  email: '$email',
  name: '$name',
  role: 'role',
  position: 'position',
  specialty: 'specialty',
  isPublic: 'isPublic',
  availability: 'availability',
  tempAvailability: 'tempAvailability',
  empType: 'empType',
  userProfileComplete: 'userProfileComplete',
  userState: 'userState',
  isRelocate: 'isRelocate',
};

// GTM reads user_id from the distinctId a previous login or registration push
// left in the dataLayer — set_user doesn't carry one. dataLayer variables
// persist across pushes; this mirror has to remember it explicitly.
let identifiedDistinctId: string | null = null;

function buildPeopleProperties(eventProps: Record<string, any>) {
  const properties: Record<string, any> = {};

  Object.entries(PEOPLE_PROPERTY_NAMES).forEach(([source, target]) => {
    if (eventProps[source] !== undefined) {
      properties[target] = eventProps[source];
    }
  });

  // The tag wraps this value in quotes, forcing a string.
  if (eventProps.userZipCode !== undefined) {
    properties.userZipCode = String(eventProps.userZipCode);
  }

  const userId = identifiedDistinctId ?? eventProps.distinctId;
  if (typeof userId === 'string' && !!userId) {
    properties.user_id = userId;
  }

  return properties;
}

function mirrorDataLayerEventToMixpanel(dataLayerEvent: Record<string, any>) {
  const eventName =
    typeof dataLayerEvent.event === 'string' && dataLayerEvent.event
      ? dataLayerEvent.event
      : 'unknown_event';
  const { event, ...eventProps } = dataLayerEvent;

  void getMixpanelInstance().then((mixpanel) => {
    if (!mixpanel) {
      return;
    }

    try {
      if (
        IDENTIFY_EVENTS.includes(eventName) &&
        typeof eventProps.distinctId === 'string' &&
        !!eventProps.distinctId
      ) {
        identifiedDistinctId = eventProps.distinctId;
        mixpanel.identify(eventProps.distinctId);
      }

      // set_user drives the people.set tag on web and isn't an event there, so
      // it isn't tracked as one here either.
      if (eventName === 'set_user') {
        mixpanel.people.set(buildPeopleProperties(eventProps));
        return;
      }

      mixpanel.track(eventName, eventProps);
    } catch (error) {
      log('[analytics] Failed to track Mixpanel event', error);
    }
  });
}

function pushAnalyticsEvent(dataLayerEvent: Record<string, any>) {
  getGoogleTagManagerDataLayer().push(dataLayerEvent);
  mirrorDataLayerEventToMixpanel(dataLayerEvent);
}

function getGoogleTagManagerDataLayer() {
  if (typeof window === 'undefined') {
    return fallbackDataLayer;
  }

  if (!Array.isArray(window['dataLayer'])) {
    window['dataLayer'] = [];
  }

  return window['dataLayer'];
}

const Events = {
  trackPurchase: function ({ transaction_id, value, items }) {
    log('[analytics] trackPurchase', {
      transaction_id,
      value,
      items,
    });
    const transformedItems = items.reduce(
      (acc, item) => ({
        ...acc,
        [item.item_id]: item,
      }),
      {}
    );
    const coupons = items.reduce((acc, item) => {
      if (!!item.coupon) {
        acc.push(item.coupon);
      }
      return acc;
    }, []);

    // Google Tag Manager "data layer"
    // Learn more: https://support.google.com/tagmanager/answer/6107169?hl=en
    const tagManagerPayload = {
      event: 'purchase',
      transaction_id,
      value: value,
      currency: 'USD',
      items: items,
      product: {
        type: !!transformedItems['JOBSUB']
          ? 'Subscription'
          : !!transformedItems['JOB']
            ? 'Premium'
            : !!transformedItems['BASIC']
              ? 'Basic'
              : 'Add-On',
        jobQuantity:
          transformedItems.JOBSUB?.quantity ||
          transformedItems.JOB?.quantity ||
          transformedItems.BASIC?.quantity,
        invQuantity: !!transformedItems.INVSUB
          ? transformedItems.INVSUB?.quantity
          : transformedItems.INV?.quantity,
        natQuantity: transformedItems.NAT?.quantity,
        coupon: [...new Set(coupons)].join(','),
      },
    };
    pushAnalyticsEvent(tagManagerPayload);
  },

  trackEvent: function (props: {
    actionType: string;
    category: string;
    label?: string;
    payload?: {};
  }) {
    log('[analytics] trackEvent', {
      actionType: props.actionType,
      category: props.category,
      label: props.label,
    });
    const action = getActionName(props.actionType);
    // Google Tag Manager "data layer"
    // Learn more: https://www.analyticsmania.com/post/datalayer-push/
    let body = {
      event: action.gtag,
      label: props.label ? props.label : '',
    };
    if (props.payload) {
      body = { ...body, ...props.payload };
    }
    pushAnalyticsEvent(body);
  },
};

const User = {
  setUser: function (props: {
    userId: number;
    email: string;
    role: string;
    name: string;
    position: string;
    specialty: string;
    isPublic: boolean;
    isRelocate?: boolean;
    availability: string;
    tempAvailability: string;
    empType: string;
    userProfileComplete: number;
    userState: string;
    userZipCode: string;
  }) {
    log('[analytics] setUser', props);
    // Google Tag Manager "data layer"
    // Learn more: https://www.analyticsmania.com/post/datalayer-push/
    pushAnalyticsEvent({
      event: 'set_user',
      ...props,
      algoliaUserToken: `authenticated_${props.userId}`,
    });
  },

  // Called from every session teardown. Without it the next user to sign in on
  // the device inherits the previous user's distinct_id. No-op on web, where
  // GTM owns the Mixpanel instance.
  resetUser: function () {
    log('[analytics] resetUser');
    identifiedDistinctId = null;
    void getMixpanelInstance().then((mixpanel) => {
      if (!mixpanel) {
        return;
      }

      try {
        mixpanel.reset();
      } catch (error) {
        log('[analytics] Failed to reset Mixpanel user', error);
      }
    });
  },
};

export default {
  Events,
  User,
};
